import { useState } from 'react';
import { DefaultTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useEvent, useRingSettings } from '@bizzabo/entities';

import useGoToHomePage from 'hooks/useGoToHomePage';
import { RingLayoutContext } from '../contexts/RingLayoutContext';
import ToolSide from './Toolbar';
import { useMessagesTabNotifications } from '../meetings/messages';
import useStyles from './Layout.styles';
import { useBreakpoints } from '../hooks/useBreakpoints';
import Navigation from './Navigation';
import Drawer from './Navigation/Drawer';
import { DrawerContent } from './Navigation/Drawer/DrawerContent';
import { useDrawerStateAtom } from './Navigation/Drawer/atoms';

type Props = {
    eventUniqueName: string;
};

const Layout: React.FC<Props> = ({ eventUniqueName, children }) => {
    // TODO change to toolbox atoms
    const { drawerState } = useDrawerStateAtom();
    const isDesktop = useMediaQuery<DefaultTheme>(theme => theme.breakpoints.up('sm'));
    const { isLoading, data: event } = useEvent(eventUniqueName);
    const { data: ringSettings } = useRingSettings(event?.id, event?.accountId, {
        enabled: !!event,
        retry: 1,
    });
    const [tool] = useState<string | null>(null);
    const classes = useStyles();
    const { ref, classStr } = useBreakpoints();
    useMessagesTabNotifications();
    const goToHomePage = useGoToHomePage();
    const menuCustomization = ringSettings?.customization?.menuCustomization;
    if (isLoading) {
        return null;
    }

    return (
        <RingLayoutContext.Provider value={classStr}>
            <div className={classes.layout}>
                <div id="main-wrap" className={classes.main}>
                    {!isDesktop && (
                        <Drawer open={drawerState}>
                            <DrawerContent
                                goToHomePage={goToHomePage}
                                eventUniqueName={eventUniqueName}
                                eventId={event.id}
                                menuCustomization={menuCustomization}
                            />
                        </Drawer>
                    )}
                    <main ref={ref}>
                        <Navigation
                            goToHomePage={goToHomePage}
                            eventUniqueName={eventUniqueName}
                            event={event}
                            isDesktop={isDesktop}
                        />
                        {children}
                    </main>
                    {isDesktop && (
                        <aside>
                            <ToolSide tool={tool} eventUniqueName={eventUniqueName} />
                        </aside>
                    )}
                </div>
                {!isDesktop && (
                    <footer className={classes.footer}>
                        <ToolSide tool={tool} eventUniqueName={eventUniqueName} />
                    </footer>
                )}
            </div>
        </RingLayoutContext.Provider>
    );
};

export default Layout;
